import moment from 'moment'
import React from 'react'
import I18n from 'resources/i18n/I18n'

const StatusCompact = ({ status, isFirstProcessing, previousAutreActions, previousAutrePrejudices }) => {
  const complaints = status.complaints || []
  const autreActions = previousAutreActions || []
  const autrePrejudices = previousAutrePrejudices || []

  return (
    <div className="compact-actions">
      {(complaints.length > 0 || autreActions.length > 0) && (
        <div>
          <span className="subtitle">{isFirstProcessing ? I18n.t('ActionsSummary') : I18n.t('NewActions')}</span>
          <ul className="actions-summary-list">
            {complaints.map((c) => (
              <li key={c.id}>
                {c.label}
                {c.asso_complaint_status && (
                  <span className="action-traceability">
                    {' '}
                    — {c.asso_complaint_status.idUser}
                    {c.asso_complaint_status.actionDate && `, ${moment(c.asso_complaint_status.actionDate).format('DD/MM/YYYY HH:mm')}`}
                  </span>
                )}
              </li>
            ))}
            {autreActions.map((a, idx) => (
              <li key={`autre-${idx}`} style={{ whiteSpace: 'pre-line' }}>
                {a.text}
                <span className="action-traceability">
                  {' '}
                  — {a.idUser}
                  {a.date && `, ${moment(a.date).format('DD/MM/YYYY HH:mm')}`}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {(status.arretTravail || status.itt || status.prejudice || autrePrejudices.length > 0) && (
        <div className="mt-2">
          <span className="subtitle">Préjudice</span>
          {status.arretTravail && <div className="subtitle-field">Arrêt de travail : {status.arretTravail} jours</div>}
          {status.itt && <div className="subtitle-field">ITT : {status.itt} jours</div>}
          {status.prejudice && <div className="subtitle-field">Préjudice estimé : {status.prejudice} €</div>}
          {autrePrejudices.map((p, idx) => (
            <div key={idx} className="subtitle-field">
              Autre : {p.text}
              <span className="action-traceability">
                {' '}
                — {p.idUser}
                {p.date && `, ${moment(p.date).format('DD/MM/YYYY HH:mm')}`}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

export default StatusCompact
